module.exports = __webpack_public_path__ + "img/delete_row.5f70ec78.svg";